import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Accordion, AccordionBody, AccordionHeader, AccordionItem, Button, Col, Collapse, Row } from 'reactstrap'




const HomeFaqs = () => {

const [open1,setOpen1] = useState(true)
const [open2,setOpen2] = useState(false)
const [open3,setOpen3] = useState(false)
const [open4,setOpen4] = useState(false)
const [open5,setOpen5] = useState(false)
const [open6,setOpen6] = useState(false)

const handleToggle1 = () => {
    setOpen1(!open1)
    console.log(open1)
}

const handleToggle2 = () => {
    setOpen2(!open2)
    console.log(open2)
}

const handleToggle3 = () => {
    setOpen3(!open3)
    console.log(open3)
}

const handleToggle4 = () => {
    setOpen4(!open4)
    console.log(open4)
}

const handleToggle5 = () => {
    setOpen5(!open5)
    console.log(open1)
}

const handleToggle6 = () => {
    setOpen6(!open6)
    console.log(open2)
}


  return (
    
    <div id='website-responsive' className='mx-md-5 mb-lg-5 mx-3' style={{ marginBottom:''}}>
        <div className='left-paddingrem rounded30 right-paddingrem pt-md-5 mx-md-5' style={{ position:'relative', backgroundColor:'#f1f1f1'}}>
            <div className='ps-xl-5 ps-5 pt-md-4 pt-3 pb-md-4 pb-3'>
                <text className='fs-ss-36 text-montserrat text-ss-primary fw-700'>
                    FAQS
                </text>
                <hr className='hr-style my-md-2' style={{ width:'65px', marginTop:'2px', marginBottom:'4px'}}/>
            </div>

            <div className='mx-3'>
                <Row className=''>
                    <Col md=''  className=''>
                        <div className='py-md-0 py-3'>
                        {/* <section className=''>

                <div className='left-paddingrem1 right-paddingrem1 ps-xl-5 '>

                <div className='row mt-' id="faq-home">

                    <div className='col-md-12 pb-md-5 pt-md-3 pb-4' style={{borderRadius:"", border:''}}>

                <Accordion className='' style={{ borderRadius:'0px', border:'none', backgroundColor:'#f1f1f1' }}>

                <AccordionItem style={{ backgroundColor:'#f1f1f1', border:'1px solid black', }} eventKey="0" >

                    <AccordionHeader onClick={() => handleToggle1()} style={{ color:'#f1f1f1'}}>

                        <span className='fs-ss-16 text-black text-montserrat fw-700 p-2' style={{fontWeight:"700", backgroundColor:''}}>
                        How can I book an appointment for the tests?
                        </span>

                    </AccordionHeader>

                    <Collapse  isOpen={open1  ? true : false}>
                    <AccordionBody className='p-1' style={{ backgroundColor:'#f1f1f1', borderTop:'1px solid black'}}>

                        <span className='fs-ss-15 text-montserrat fw-600' >

                        You can schedule an appointment immediately through our website whenever convenient for you.

                        </span>

                    </AccordionBody>
                </Collapse>
                </AccordionItem>




                <AccordionItem style={{ backgroundColor:'#f1f1f1', border:'1px solid black', }} eventKey="1" >

                    <AccordionHeader onClick={() => handleToggle2()}>

                        <span className='fs-ss-16 text-black text-montserrat fw-700 p-2' style={{fontWeight:"700"}}>

                        Do I have to pay for tests?
                        
                        </span>

                    </AccordionHeader>
                    <Collapse isOpen={open2 === true ? true : false}>
                    <AccordionBody className='p-1' style={{ borderTop:'1px solid black' }}>

                        <span className='fs-ss-15 text-montserrat fw-600'>

                        No, United Lab Care offers you the RSV/Influenza/Covid-19 tests at no cost to you, if you have viable health insurance. Accepting Private Health Insurances, including <strong>Medicaid commercial and Medicare.</strong> Otherwise, self-pay is also available.



                        </span>

                    </AccordionBody>
</Collapse>
                </AccordionItem>




                <AccordionItem style={{ backgroundColor:'#f1f1f1', border:'1px solid black', }} eventKey="2" className=''>

                    <AccordionHeader onClick={() => handleToggle3()}>

                        <span className='fs-ss-16 text-black text-montserrat fw-700 p-2' style={{fontWeight:"700"}}>

                        Is RSV identical to the flu?
                        
                        </span>

                    </AccordionHeader>
                    <Collapse isOpen={open3 === true ? true : false}>
                    <AccordionBody className='p-1' style={{ borderTop:'1px solid black' }}>

                        <span className='fs-ss-15 text-montserrat fw-600'>
                        The flu usually starts suddenly, while COVID and RSV symptoms begin gradually. They all cause similar symptoms. However, specific side effects often rule one sickness over another. For instance, flu and fever are much more prevalent than RSV. 
                        </span>

                    </AccordionBody>
</Collapse>
                </AccordionItem>

                <AccordionItem style={{ backgroundColor:'#f1f1f1', border:'1px solid black', }} eventKey="2" className=''>

                <AccordionHeader onClick={() => handleToggle4()}>

                    <span className='fs-ss-16 text-black text-montserrat fw-700 p-2' style={{fontWeight:"700"}}>
                    Is it challenging to acquire a Covid or RSV test at United Lab Care?
                    </span>

                </AccordionHeader>
                <Collapse isOpen={open4 === true ? true : false}>
                <AccordionBody className='p-1' style={{ borderTop:'1px solid black' }}>

                    <span className='fs-ss-15 text-montserrat fw-600'>
                    No, there are three simple actions you can take to get tested.<br/>
                    Your PCP, or one of our Telehealth Doctors, can select the tests they believe are necessary based on your symptoms. After that, you and your Doctor can view the results and get your treatment plan started!
                    </span>

                </AccordionBody>
                </Collapse>
                </AccordionItem>

                <AccordionItem style={{ backgroundColor:'#f1f1f1', border:'1px solid black', }} eventKey="2" className=''>

                <AccordionHeader onClick={() => handleToggle5()}>

                    <span className='fs-ss-16 text-black text-montserrat fw-700 p-2' style={{fontWeight:"700"}}>

                    Which tests do you administer to detect RSV?
                
                    </span>

                </AccordionHeader>
                <Collapse isOpen={open5 === true ? true : false}>
                <AccordionBody className='p-1' style={{ borderTop:'1px solid black' }}>

                    <span className='fs-ss-15 text-montserrat fw-600'>
                    The two most common tests used to diagnose RSV infections are: Tests based on molecular and rapid RSV antigen.
                    </span>

                </AccordionBody>
                </Collapse>
                </AccordionItem>

                <AccordionItem style={{ backgroundColor:'#f1f1f1', border:'1px solid black', }} eventKey="2" className=''>

                <AccordionHeader onClick={() => handleToggle6()}>

                    <span className='fs-ss-16 text-ss-black text-montserrat fw-600 p-2' style={{fontWeight:"700"}}>

                    How do you do an RSV test?
                    
                    </span>

                </AccordionHeader>
                <Collapse isOpen={open6 === true ? true : false}>
                <AccordionBody className='p-1' style={{ borderTop:'1px solid black' }}>

                    <span className=''>
                    <text className='fs-ss-15 text-montserrat fw-600'>Tests to diagnose RSV are done on a sample of fluid from your nose. There are different ways to collect the sample:</text><br/><br/>

                    1) Nasal aspirate or wash. <br/>
                    2) Nasal swab test. <br/>
                    </span>

                </AccordionBody>
                </Collapse>
                </AccordionItem>
                <AccordionItem style={{ backgroundColor:'#f1f1f1', border:'1px solid black', }} eventKey="2" className=''>

                <AccordionHeader onClick={() => handleToggle6()}>

                    <span className='fs-ss-16 text-ss-black text-montserrat fw-600 p-2' style={{fontWeight:"700"}}>

                    What is toxicology testing, and how does United Lab Care help with toxicology testing?
                    
                    </span>

                </AccordionHeader>
                <Collapse isOpen={open6 === true ? true : false}>
                <AccordionBody className='p-1' style={{ borderTop:'1px solid black' }}>

                    <span className=''>
                    <text className='fs-ss-15 text-montserrat fw-600'>Toxicology testing detects drugs in biological samples (urine, blood) to identify recent drug use, aiding compliance checks and safety measures. ULC offers comprehensive toxicology testing services using state-of-the-art equipment and expert analysis for precise results.</text>
                    </span>

                </AccordionBody>
                </Collapse>
                </AccordionItem>
                <AccordionItem style={{ backgroundColor:'#f1f1f1', border:'1px solid black', }} eventKey="2" className=''>

                <AccordionHeader onClick={() => handleToggle6()}>

                    <span className='fs-ss-16 text-ss-black text-montserrat fw-600 p-2' style={{fontWeight:"700"}}>

                    Can blood tests detect multiple STIs/STDs at once?
                    
                    </span>

                </AccordionHeader>
                
                <Collapse isOpen={open6 === true ? true : false}>
                <AccordionBody className='p-1' style={{ borderTop:'1px solid black' }}>

                    <span className=''>
                    <text className='fs-ss-15 text-montserrat fw-600'>Some blood tests can screen for multiple infections simultaneously, providing comprehensive insights.</text>
                    </span>

                </AccordionBody>
                </Collapse>
                </AccordionItem>
               
                <AccordionItem style={{ backgroundColor:'#f1f1f1', border:'1px solid black', }} eventKey="2" className=''>

                <AccordionHeader onClick={() => handleToggle6()}>

                    <span className='fs-ss-16 text-ss-black text-montserrat fw-600 p-2' style={{fontWeight:"700"}}>

                    When will I get the results of the tests?
                    
                    </span>

                </AccordionHeader>
                <Collapse isOpen={open6 === true ? true : false}>
                <AccordionBody className='p-1' style={{ borderTop:'1px solid black' }}>

                    <span className=''>
                    <text className='fs-ss-15 text-montserrat fw-600'>Turnaround time for these tests are between 24-48 hours but your doctor could receive your results in under 24 hours. We can deliver results for blood work in the same day.</text>
                    </span>

                </AccordionBody>
                </Collapse>
                </AccordionItem>

                </Accordion>
                </div>
                </div>
                </div>
                </section> */}

                

<section className='faq'>

                    <div className='container-zk'>

                        <div className='row pt-md-0 pt-0 pb-4' id="faq-home">

                                <div className='col-md10 mxauto p-md5 pb-4' style={{borderRadius:"30px"}}>

                                    <div className='accordion accordion-flush px-md-4 px-2' id='accordionFlushExample'>

                                        <div className='accordion-item'>

                                            <h2 className='accordion-header' style={{ borderBottom:'1px solid black'}} id='flush-headingOne'>

                                                <button style={{ backgroundColor:'#f1f1f1'}} className='accordion-button collapsed' type='button' data-bs-toggle='collapse' data-bs-target='#flush-collapseOne' aria-expanded='false' aria-controls='flush-collapseOne'>

                                                    <span className='fs-ss-16 text-montserrat my-1 fw-700 text-zksecondary' style={{fontWeight:"600"}}>How can I book an appointment for the tests?</span>

                                                </button>

                                            </h2>

                                            <div id='flush-collapseOne' className='accordion-collapse collapse' aria-labelledby='flush-headingOne' data-bs-parent='#accordionFlushExample'>

                                                <div className='accordion-body' style={{ backgroundColor:'#f1f1f1', borderBottom:'1px solid black'}}>

                                                    <span className='fs-ss-15 text-montserrat fw-600'>You can schedule an appointment immediately through our website whenever convenient for you. </span>

                                                </div>

                                            </div>

                                        </div>

                                        {/* <hr /> */}

                                        

                                        <div className='accordion-item pt-'>

                                            <h2 className='accordion-header' style={{ borderBottom:'1px solid black'}} id='flush-headingThree'>

                                                <button style={{ backgroundColor:'#f1f1f1'}} className='accordion-button collapsed' type='button' data-bs-toggle='collapse' data-bs-target='#flush-collapseThree' aria-expanded='false' aria-controls='flush-collapseThree'>

                                                    <span className='fs-ss-16 text-montserrat my-1  text-zk-secondary' style={{fontWeight:"600"}}>Do I have to pay for tests? </span>

                                                </button>

                                            </h2>

                                            <div id='flush-collapseThree' className='accordion-collapse collapse' aria-labelledby='flush-headingThree' data-bs-parent='#accordionFlushExample'>

                                                <div className='accordion-body' style={{ backgroundColor:'#f1f1f1', borderBottom:'1px solid black'}}>

                                                    <span className='fs-ss-15 text-montserrat fw-600'>No, United Lab Care offers you the RSV/Influenza/Covid-19 tests at no cost to you, if you have viable health insurance. Accepting Private Health Insurances, including<strong> Medicaid commercial and Medicare.</strong> Otherwise, self-pay is also available.</span>

                                                </div>

                                            </div>

                                        </div>

 

                                        <div className='accordion-item pt-'>

                                            <h2 className='accordion-header' style={{ borderBottom:'1px solid black'}} id='flush-headingFour'>

                                                <button style={{ backgroundColor:'#f1f1f1'}} className='accordion-button collapsed' type='button' data-bs-toggle='collapse' data-bs-target='#flush-collapseFour' aria-expanded='false' aria-controls='flush-collapseFour'>

                                                    <span className='fs-ss-16 text-montserrat my-1 text-zk-secondary' style={{fontWeight:"600"}}>Is RSV identical to the flu?</span>

                                                </button>

                                            </h2>

                                            <div id='flush-collapseFour' className='accordion-collapse collapse' aria-labelledby='flush-headingFour' data-bs-parent='#accordionFlushExample'>

                                                <div className='accordion-body' style={{ backgroundColor:'#f1f1f1', borderBottom:'1px solid black'}}>

                                                    <span className='fs-ss-15 text-montserrat fw-600'>The flu usually starts suddenly, while COVID and RSV symptoms begin gradually. They all cause similar symptoms. However, specific side effects often rule one sickness over another. For instance, flu and fever are much more prevalent than RSV.   </span>

                                                </div>

                                            </div>

                                        </div>

                                        <div className='accordion-item pt-'>

                                            <h2 className='accordion-header' style={{ borderBottom:'1px solid black'}} id='flush-headingFive'>

                                                <button style={{ backgroundColor:'#f1f1f1'}} className='accordion-button collapsed' type='button' data-bs-toggle='collapse' data-bs-target='#flush-collapseFive' aria-expanded='false' aria-controls='flush-collapseFive'>

                                                    <span className='fs-ss-16 text-montserrat my-1 text-zk-secondary' style={{fontWeight:"600"}}>Is it challenging to acquire a Covid or RSV test at United Lab Care? </span>

                                                </button>

                                            </h2>

                                            <div id='flush-collapseFive' className='accordion-collapse collapse' aria-labelledby='flush-headingFive' data-bs-parent='#accordionFlushExample'>

                                                <div className='accordion-body' style={{ backgroundColor:'#f1f1f1', borderBottom:'1px solid black'}}>

                                                    <span className='fs-ss-15 text-montserrat fw-600'>No, there are three simple actions you can take to get tested.

Your PCP, or one of our Telehealth Doctors, can select the tests they believe are necessary based on your symptoms. After that, you and your Doctor can view the results and get your treatment plan started!</span>

                                                </div>

                                            </div>

                                        </div>

                                        <div className='accordion-item pt-'>

                                            <h2 className='accordion-header' style={{ borderBottom:'1px solid black'}} id='flush-headingSix'>

                                                <button style={{ backgroundColor:'#f1f1f1'}} className='accordion-button collapsed' type='button' data-bs-toggle='collapse' data-bs-target='#flush-collapseFSix' aria-expanded='false' aria-controls='flush-collapseFSix'>

                                                    <span className='fs-ss-16 text-montserrat my-1 text-zk-secondary' style={{fontWeight:"600"}}>Which tests do you administer to detect RSV? </span>

                                                </button>

                                            </h2>

                                            <div id='flush-collapseFSix' className='accordion-collapse collapse' aria-labelledby='flush-headingSix' data-bs-parent='#accordionFlushExample'>

                                                <div className='accordion-body' style={{ backgroundColor:'#f1f1f1', borderBottom:'1px solid black'}}>

                                                    <span className='fs-ss-15 text-montserrat fw-600'>The two most common tests used to diagnose RSV infections are: Tests based on molecular and rapid RSV antigen. </span>

                                                </div>

                                            </div>

                                        </div>

 

                                        <div className='accordion-item pt-'>

                                            <h2 className='accordion-header' style={{ borderBottom:'1px solid black'}} id='flush-headingSeven'>

                                                <button style={{ backgroundColor:'#f1f1f1'}} className='accordion-button collapsed' type='button' data-bs-toggle='collapse' data-bs-target='#flush-collapseFSeven' aria-expanded='false' aria-controls='flush-collapseFSeven'>

                                                    <span className='fs-ss-16 text-montserrat my-1 text-zk-secondary' style={{fontWeight:"600"}}>How do you do an RSV test?   </span>

                                                </button>

                                            </h2>

                                            <div id='flush-collapseFSeven' className='accordion-collapse collapse' aria-labelledby='flush-headingSeven' data-bs-parent='#accordionFlushExample'>

                                                <div className='accordion-body' style={{ backgroundColor:'#f1f1f1', borderBottom:'1px solid black'}}>

                                                    <span className='fs-ss-15 text-montserrat fw-600'>Tests to diagnose RSV are done on a sample of fluid from your nose. There are different ways to collect the sample:<br/>

1) Nasal aspirate or wash.
<br/>
2) Nasal swab test. </span>

                                                </div>

                                            </div>

                                        </div>

                                        <div className='accordion-item pt-'>

                                            <h2 className='accordion-header' style={{ borderBottom:'1px solid black'}} id='flush-headingEight'>

                                                <button style={{ backgroundColor:'#f1f1f1'}} className='accordion-button collapsed' type='button' data-bs-toggle='collapse' data-bs-target='#flush-collapseEight' aria-expanded='false' aria-controls='flush-collapseEight'>

                                                    <span className='fs-ss-16 text-montserrat my-1 text-zk-secondary' style={{fontWeight:"600"}}> What is toxicology testing, and how does United Lab Care help with toxicology testing? </span>

                                                </button>

                                            </h2>

                                            <div id='flush-collapseEight' className='accordion-collapse collapse' aria-labelledby='flush-headingEight' data-bs-parent='#accordionFlushExample'>

                                                <div className='accordion-body' style={{ backgroundColor:'#f1f1f1', borderBottom:'1px solid black'}}>

                                                    <span className='fs-ss-15 text-montserrat fw-600'>Toxicology testing detects drugs in biological samples (urine, blood) to identify recent drug use, aiding compliance checks and safety measures. ULC offers comprehensive toxicology testing services using state-of-the-art equipment and expert analysis for precise results. </span>

                                                </div>

                                            </div>

                                        </div>

                                        <div className='accordion-item pt-'>

                                            <h2 className='accordion-header' style={{ borderBottom:'1px solid black'}} id='flush-headingNone' >

                                                <button style={{ backgroundColor:'#f1f1f1'}} className='accordion-button collapsed' type='button' data-bs-toggle='collapse' data-bs-target='#flush-collapseNine' aria-expanded='false' aria-controls='flush-collapseNine'>

                                                    <span className='fs-ss-16 text-montserrat my-1 text-zk-secondary' style={{fontWeight:"600"}}>Can blood tests detect multiple STIs/STDs at once? </span>

                                                </button>

                                            </h2>

                                            <div id='flush-collapseNine' className='accordion-collapse collapse' aria-labelledby='flush-headingNone' data-bs-parent='#accordionFlushExample'>

                                                <div className='accordion-body' style={{ backgroundColor:'#f1f1f1', borderBottom:'1px solid black'}}>

                                                    <span className='fs-ss-15 text-montserrat fw-600'>Some blood tests can screen for multiple infections simultaneously, providing comprehensive insights. </span>

                                                </div>

                                            </div>

                                        </div>

                                        <div className='accordion-item pt-'>

                                            <h2 className='accordion-header' style={{ borderBottom:'1px solid black'}} id='flush-headingTen'>

                                                <button style={{ backgroundColor:'#f1f1f1'}} className='accordion-button collapsed' type='button' data-bs-toggle='collapse' data-bs-target='#flush-collapseTen' aria-expanded='false' aria-controls='flush-collapseTen'>

                                                    <span className='fs-ss-16 text-montserrat my-1 text-zk-secondary' style={{fontWeight:"600"}}>When will I get the results of the tests? </span>

                                                </button>

                                            </h2>

                                            <div id='flush-collapseTen' className='accordion-collapse collapse' aria-labelledby='flush-headingTen' data-bs-parent='#accordionFlushExample'>

                                                <div className='accordion-body' style={{ backgroundColor:'#f1f1f1', borderBottom:'1px solid black'}}>

                                                    <span className='fs-ss-15 text-montserrat fw-600'>Turnaround time for these tests are between 24-48 hours but your doctor could receive your results in under 24 hours. We can deliver results for blood work in the same day. </span>

                                                </div>

                                            </div>

                                        </div>

                                        

                                    </div>

                                </div>

                        </div>

                    </div>

                </section>
                        </div>
                    </Col>
                    <Col md='5' className='display-none-1150 mt-md5' style={{ marginTop:'-3rem'}}>
                         <div className='rounded30 img-w10 mt-md-5' style={{backgroundImage:'url("home/Home-page-Newsletter-bg-v1.webp")',position:'absolute', backgroundSize:'contain', backgroundPosition:'center', backgroundRepeat:'no-repeat', height:'600px', width:'', display:'flex', justifyContent:'center', alignItems:'center' }}>
                            <div className='fs-ss-36-2 text-montserrat fw-600 text-white '>
                                <text className='lh-1-4'>
                                    <center>LET US MAKE<br/> TESTING EASIER<br/> FOR YOU!</center>
                                </text>
                                <div className='mt-5'>
                                <center>
                                <Link to='/book-appointment'>
                        <Button className='btn-ss-secondary rounded20 ' style={{  boxShadow:'1px 1px 6px 0 rgba(0,0,0,.4)'}}>
                            <text className='text-montserrat fw-600 fs-ss-18' style={{ padding:'',}}>
                                Book Appointment
                            </text>
                        </Button>
                    </Link>
                            </center>
                                </div>
                            </div>
                        </div>   

                                                
                    </Col>
                </Row>
            </div>
        </div>

        <div className='rounded30 img-w23 display-block2 mb-md-0 my-5' style={{backgroundImage:'url("home/Home-page-Newsletter-bg-v1.webp")',position:'', backgroundSize:'cover', backgroundPosition:'center', backgroundRepeat:'no-repeat', height:'580px', width:'', display:'flex', justifyContent:'center', alignItems:'center' }}>
                            <div className='fs-ss-32-2 text-montserrat fw-600 text-white px-5 px-sm-5  '>
                                <text className='lh-1-4'>
                                    <center>LET US MAKE TESTING EASIER FOR YOU!</center>
                                </text>
                                <div className='mt-4'>
                            </div>
                                <center>
                                <Link to='/book-appointment'>
                                <Button className='btn-ss-secondary rounded20 ' style={{  boxShadow:'1px 1px 6px 0 rgba(0,0,0,.4)'}}>
                                    <text className='text-montserrat fw-600 fs-ss-18' style={{ padding:'',}}>
                                        Book Appointment
                                    </text>
                                </Button>
                                </Link>
                            </center>
                                </div>
                        </div> 
    </div>
  )
}

export default HomeFaqs